import { app } from '../../../../app';
import { Controller } from './add-phone-number.controller';

app.component('addPhoneNumber', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./add-phone-number.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/add/add-phone-number.component.js